module.exports = __webpack_public_path__ + "static/media/descriptive reportt.9b04f7e9.svg";